import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskProformaIssueFormsDirectRoute: InvariantJiraRoute = {
	name: 'servicedesk-proforma-issue-forms-direct',
	path: '/jira/servicedesk/projects/:projectKey/forms/form/direct/:templateFormId/:issueTypeId?',
	exact: true,
};
